import * as React from "react";
import { forwardRef } from "react";
const SvgPlaceholder = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#98A9BC", fillRule: "evenodd", d: "M5.001 11.889v-10H3v-1h6v1H7v10h1v-1.5h6.5v-5H8v-1.5h7.001a1 1 0 0 1 1 1v6c0 .552-.449 1.001-1 1.001H7v1.998H5V11.89H1c-.552 0-1-.45-1-1.002v-6a1 1 0 0 1 1-1h3V5.39H1.5v5H4v1.5zm-2.001 3v-1h6v1z", clipRule: "evenodd" }));
const ForwardRef = forwardRef(SvgPlaceholder);
export { ForwardRef as ReactComponent };
